module.exports = __webpack_public_path__ + "img/flash_w.91593e7e.svg";